import { useQuery } from "@tanstack/react-query"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getReferralInvited, getReferralStats } from "@/api/gameApi"

export default function ReferralPage() {
  const statsQ = useQuery({
    queryKey: ["referral-stats"],
    queryFn: getReferralStats,
  })
  const invitedQ = useQuery({
    queryKey: ["referral-invited"],
    queryFn: () => getReferralInvited({ take: 30 }),
  })

  const stats = statsQ.data

  return (
    <GameScreenLayout title="Рефералы" backTo="/play/profile">
      {stats ? (
        <section className="mb-4 rounded-xl border border-white/10 p-4 text-sm">
          <p className="font-medium">Ваш код: {stats.publicGameCode}</p>
          <p className="mt-1 text-guardians-muted">
            Приглашено {stats.totalInvited} · награда {stats.rewardChakra} чакры
          </p>
          <p className="text-xs text-guardians-muted">
            Осталось наград в месяце: {stats.monthlyRewardsRemaining}/
            {stats.monthlyRewardLimit}
          </p>
        </section>
      ) : null}

      {invitedQ.isLoading ? (
        <p className="text-sm text-guardians-muted">Список…</p>
      ) : (
        <ul className="space-y-2 text-sm">
          {(invitedQ.data?.items ?? []).map((item) => (
            <li key={item.id} className="rounded-lg border border-white/10 px-3 py-2">
              <p>{item.referred?.nickname ?? "—"}</p>
              <p className="text-xs text-guardians-muted">
                {item.status} · {item.referred?.publicGameCode}
              </p>
            </li>
          ))}
        </ul>
      )}
    </GameScreenLayout>
  )
}
